/**
 *
 * @module paymentInformation
 *
 */

import Check from 'check-types';
import Services from './../services/entry';

const AddressableCreditCard = Services.Commerce.AddressableCreditCard;
const Currency = Services.Commerce.Currency;

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    instanceStrict,
    nonEmptyString
} = Check.assert;

/**
 *
 * @class PaymentInformation
 * @desc Contains information necessary to place an order.
 *
 */
export default class PaymentInformation {

    /**
     *
     * @param {String} creditCardNumber
     * @param {SDK.Services.Commerce.AddressableCreditCard} addressableCreditCard
     * @param {SDK.Services.Commerce.Currency} currency
     * @throws {InvalidArgumentException}
     *
     */
    constructor(creditCardNumber, addressableCreditCard, currency) {

        const errorMessage = {
            ctor: 'PaymentInformation(creditCardNumber, addressableCreditCard)',
            get creditCardNumber() {
                return `${this.ctor} creditCardNumber should be a String with length`;
            },
            get addressableCreditCard() {
                return `${this.ctor} needs SDK.Services.Commerce.AddressableCreditCard instance`;
            },
            get currency() {
                return `${this.ctor} needs SDK.Services.Commerce.Currency instance`;
            }
        };

        nonEmptyString(creditCardNumber, errorMessage.creditCardNumber, InvalidArgumentException);
        instanceStrict(addressableCreditCard, AddressableCreditCard, errorMessage.addressableCreditCard, InvalidArgumentException); // eslint-disable-line
        instanceStrict(currency, Currency, errorMessage.currency, InvalidArgumentException);

        instanceStrict(
            addressableCreditCard,
            AddressableCreditCard,
            errorMessage.addressableCreditCard,
            InvalidArgumentException
        );

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.creditCardNumber = creditCardNumber;

        /**
         *
         * @access public
         * @type {SDK.Services.Commerce.AddressableCreditCard}
         *
         */
        this.addressableCreditCard = addressableCreditCard;

        /**
         *
         * @access public
         * @type {SDK.Services.Commerce.Currency}
         *
         */
        this.currency = currency;

    }

}



// WEBPACK FOOTER //
// ./src/commerce/paymentInformation.js